import {Component, Prop, Vue} from "vue-property-decorator";
import CabinClass from "@/app/shared/models/cabin-class.model";
import {Inject} from "inversify-props";
import {TimeService} from "@/app/services/time.service";

@Component<CreditFaresLister>({
    components: ({})
})
export default class CreditFaresLister extends Vue {
    @Inject() private readonly timeService: TimeService;
    @Prop({default: []}) fares: [];

    private cabinClass = CabinClass;

}
